import { createApi } from '@reduxjs/toolkit/query/react';
import { axiosBaseQuery } from './axiosBaseQuery';
import { buildQuery } from '../../../utils/buildQuery';

export interface ScanExportFilters {
  readerId?: string;
  passId?: string;
  scanType?: string;
  status?: string;
  validationType?: string;
  groupTags?: string[];
  passTemplateId?: string[];
  createdAfter?: string;
  createdBefore?: string;
}

export const scanApi = createApi({
  reducerPath: 'scanApi',
  baseQuery: axiosBaseQuery(),
  endpoints: (builder) => ({
    exportScans: builder.mutation<
      void,
      {
        entityUuid?: string;
        email: string;
        timezone: string;
        includePassFields: boolean;
        filters?: ScanExportFilters;
      }
    >({
      query: ({
        entityUuid,
        email,
        timezone,
        includePassFields,
        filters = {},
      }) => {
        const qs = buildQuery({
          export: 'true',
          entity: entityUuid,
          readerId: filters.readerId,
          passId: filters.passId,
          scanType: filters.scanType,
          status: filters.status,
          validationType: filters.validationType,
          groupTags: filters.groupTags?.length ? filters.groupTags : undefined,
          passTemplateId: filters.passTemplateId?.length
            ? filters.passTemplateId
            : undefined,
          createdAfter: filters.createdAfter,
          createdBefore: filters.createdBefore,
          includePassFields: includePassFields || undefined,
          timezone,
          email,
        });

        return `api/v1/scans${qs ? `?${qs}` : ''}`;
      },
    }),
  }),
});

export const { useExportScansMutation } = scanApi;
